export const ETAPA_ASSISTENCIA_TECNICA = {
    SOLICITACAO_DE_MANUTENCAO: {
        NR_ETAPA: 1,
        CD_ETAPA: 1,
    },
    AVALIACAO_DE_PROCEDENCIA: {
        NR_ETAPA: 2,
        CD_ETAPA: 2,
    },
    AGENDAMENTO_VISTORIA_INICIAL: {
        NR_ETAPA: 3,
        CD_ETAPA: 3,
    },
    EXECUCAO_VISTORIA_INICIAL: {
        NR_ETAPA: 4,
        CD_ETAPA: 4,
    },
    AGENDAR_MANUTENCAO: {
        NR_ETAPA: 5,
        CD_ETAPA: 5,
    },
    EXECUCAO_DE_MANUTENCAO: {
        NR_ETAPA: 6,
        CD_ETAPA: 6,
    },
    PESQUISA_SATISFACAO: {
        NR_ETAPA: 7,
        CD_ETAPA: 7,
    },
    FECHAMENTO_DE_MANUTENCAO: {
        NR_ETAPA: 8,
        CD_ETAPA: 8,
    },
    VALIDACAO_ATENDIMENTO_NAO_PROCEDENTE: {
        NR_ETAPA: 9,
        CD_ETAPA: 9,
    },
    DUVIDA_TECNICA: {
        NR_ETAPA: 10,
        CD_ETAPA: 10,
    },
};
